import { render, staticRenderFns } from "./CraftManage.vue?vue&type=template&id=70bd64e9&scoped=true&"
import script from "./CraftManage.vue?vue&type=script&lang=js&"
export * from "./CraftManage.vue?vue&type=script&lang=js&"
import style0 from "./CraftManage.vue?vue&type=style&index=0&id=70bd64e9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd64e9",
  null
  
)

export default component.exports